import React, { Dispatch, SetStateAction, useState } from "react";
import {
	Button,
	Container,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { useTraderProvider } from "../../providers/TraderProvider";
import { useSnackbar } from "../../providers/SnackbarProvider";
import { useTranslation } from "react-i18next";

const AddSubaccountModal = ({
	open,
	setOpen,
}: {
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
	const [inputValue, setInputValue] = useState("");
	const { handleAddSubAccount } = useTraderProvider();
	const { openLoadingSnackbar, closeLoadingSnackbar } = useSnackbar();
	const { t } = useTranslation();
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

	const handleClose = () => {
		setOpen(false);
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setInputValue(event.target.value);
	};

	const handleSubmit = async () => {
		openLoadingSnackbar();
		await handleAddSubAccount(inputValue);
		closeLoadingSnackbar();
		handleClose();
	};

	return (
		<Dialog
			fullScreen={fullScreen}
			open={open}
			onClose={handleClose}
			aria-labelledby="responsive-dialog-title"
		>
			<DialogTitle id="responsive-dialog-title">
				{t("trader.sub_account.add_subaccount")}
			</DialogTitle>
			<DialogContent>
				<Container sx={{ padding: "16px" }}>
					<TextField
						autoFocus
						id="input"
						label="Subaccount username"
						type="text"
						fullWidth
						value={inputValue}
						onChange={handleChange}
						color="secondary"
					/>
				</Container>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="secondary">
					{t("trader.sub_account.cancel")}
				</Button>
				<Button onClick={handleSubmit} color="secondary" autoFocus>
					{t("trader.sub_account.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddSubaccountModal;
